module.exports = __webpack_public_path__ + "media/images/case_studies/comme_j_aime/hero-4046438698cc9cac4ce292f6eaaadb26.svg";